import { useSelectCurrentSymbology } from 'portfolio/store/selectors';
import { useAppSelector } from 'store/hooks';
import { selectIndexMappingsInSymbology } from 'symbols/indexMappings/store/IndexMappingsSlice';
import { useFetchIndexMappingsUserPreference } from 'symbols/indexMappings/hooks';

export const useSelectIndexMappings = () => {
    useFetchIndexMappingsUserPreference();

    const symbology = useSelectCurrentSymbology();
    return useAppSelector((state) =>
        selectIndexMappingsInSymbology(state, symbology)
    );
};
